export default [
  {
    path: '/activity/christmas',
    name: 'christmas',
    component: () => import('@/views/activity/christmas'),
    meta: { title: '圣诞节活动' }
  },
  {
    path: '/activity/invest',
    name: 'invest',
    component: () => import('@/views/activity/invest'),
    meta: { title: '投资大师比赛' }
  },
]



// WEBPACK FOOTER //
// ./src/router/config/activityRouter.js